export const isDevEnvironment = (): boolean => import.meta.env.DEV;

export const isSuccessful = (response: Response): boolean => response.status === 200;
